//FORM
export const SHOW_FORM = 'SHOW_FORM'
export const GET_FORM = 'GET_FORM'
export const ADD_FORM = 'ADD_FORM'
export const VALIDATE_FORM = 'VALIDATE_FORM'
export const ACTUAL_FORM = 'ACTUAL_FORM'
export const UPDATE_FORM = 'UPDATE_FORM'
export const DELETE_FORM = 'DELETE_FORM'
export const FORM_ERROR = 'FORM_ERROR'

//ALERT
export const SHOW_ALERT = 'SHOW_ALERT'
export const HIDE_ALERT = 'HIDE_ALERT'

// AUTH  
export const SUCCESFUL_REGISTER = 'SUCCESFUL_REGISTER'
export const ERROR_REGISTER = 'ERROR_REGISTER'
export const GET_USER = 'GET_USER'
export const SUCCESFUL_LOGIN = 'SUCCESFUL_LOGIN'
export const ERROR_LOGIN = 'ERROR_LOGIN'
export const LOGOUT = 'LOGOUT'




